import React from 'react';

const initialState = {
   open: false,
   mostrarBotonesAccion: false,
   children: null,
   extraProps: {}
};

const sliceConfig = {
   name: 'modal',
   initialState: initialState,
   reducers: {
      close(state) {
         state.open = initialState.open;
         state.mostrarBotonesAccion = initialState.mostrarBotonesAccion;
         state.children = initialState.children;
         state.extraProps = initialState.extraProps;
      },
      open(state, action) {
         state.children = action.payload.children;
         state.open = true;
         state.extraProps = action.payload.extraProps;
      }
   }
};

const Close = 'modal/close';
const Open = 'modal/open';
const OpenMsg = 'msg/open';

export function open(Component, componentProps = {}, callbackOnClose = null, containerProps = {}) {
   return async function (dispatch) {
      const {open, onClose, children, ...options} = containerProps;
      async function handleCloseModalCallback(data) {
         try {
            if (callbackOnClose) {
               await callbackOnClose(data);
               dispatch({type: Close});
            } else {
               dispatch({type: Close});
            }
         } catch (error) {
            //dispatch(openMsg(dev.getErrorMsg(error)));
            dispatch({
               type: OpenMsg,
               payload: {
                  mensaje: error.toString(),
                  accionAceptar: null,
                  aceptarLabel: 'Eliminar'
               }
            });
         }
      }
      function handleOnClose() {
         dispatch({
            type: Close
         });
      }
      dispatch({
         type: Open,
         payload: {
            extraProps: {
               ...options,
               onClose: handleOnClose
            },

            children: (
               <Component
                  closeModalCallback={handleCloseModalCallback}
                  closeModal={handleOnClose}
                  {...componentProps}
               />
            )
         }
      });
   };
}

export default sliceConfig;
